<template>
  <v-toolbar :color="ui.cardColor">
    <v-toolbar-title :class="ui.textSubheadingBold">
      <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
        <v-avatar>
        <v-icon> health_and_safety </v-icon>
        </v-avatar>
        Safety
      </v-chip>
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <GetRegisterListPage :data="{tag: 'K6', tagd: 'S1', tags: 'S1', size: 'icon'}"
    v-if="this.licenceOK &&
    this.userOK &&
    this.getUser.pref.select.cauth !== null"/>
    <GetRegisterListPage :data="{tag: 'K6', tagd: 'S6', tags: 'S6', size: 'icon'}"
    v-if="this.licenceOK &&
    this.userOK &&
    this.getUser.pref.select.cauth !== null"/>
    <GetRegisterListPage :data="{tag: 'K6', tagd: 'B1', tags: 'B1', size: 'icon'}"
    v-if="this.licenceOK &&
    this.userOK &&
    this.getUser.pref.select.cauth !== null"/>
  </v-toolbar>
</template>

<script>
import apptheme from "@/frame/theme/mixins/apptheme.js";
import GetRegisterListPage from "@/data/register/components/GetRegisterListPage";
import licenceFunctions from "@/admin/functions/mixins/licenceFunctions.js";
import adminFunctions from "@/admin/functions/mixins/adminFunctions.js";
import { mapGetters } from "vuex";

export default {
  components: {
    GetRegisterListPage
  },
  computed: {
    ...mapGetters(["getDetail", "getCompany"])
  },
  mixins: [apptheme, licenceFunctions, adminFunctions],
  data() {
    return {
      valid: true
    };
  }
};
</script>
